import React, { useEffect, useState } from "react";
import DagonetHeader from "./DagonetHeader.jsx";
import ProfitStats from "./ProfitStats.jsx";
import BalanceInfo from "./BalanceInfo.jsx";
import BettingChart from "./BettingChart.jsx";
import BettingTable from "./BettingTable.jsx";
import { BOTS, botFromHash, hashForBot } from "./dagonetBots.mjs";

async function fetchJson(url, options) {
  const response = await fetch(url, options);
  if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
  return response.json();
}

export default function Dagonet() {
  const [bot, setBot] = useState(() => botFromHash(window.location.hash));
  const [data, setData] = useState(null);
  const [bettingData, setBettingData] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const syncBotToUrl = () => setBot(botFromHash(window.location.hash));
    window.addEventListener('hashchange', syncBotToUrl);
    window.addEventListener('popstate', syncBotToUrl);
    return () => {
      window.removeEventListener('hashchange', syncBotToUrl);
      window.removeEventListener('popstate', syncBotToUrl);
    };
  }, []);

  const selectBot = (nextBot) => {
    if (!BOTS[nextBot]) return;
    setBot(nextBot);
    const nextHash = hashForBot(nextBot);
    if (nextHash) {
      window.location.hash = nextHash;
    } else {
      window.history.pushState(null, '', `${window.location.pathname}${window.location.search}`);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const query = new URLSearchParams({ bot }).toString();
    const options = { signal: controller.signal };

    setData(null);
    setBettingData(null);
    setActive(null);
    document.title = BOTS[bot].name;

    fetchJson(`/api/dagonet/info?${query}`, options)
      .then(setData)
      .catch(err => {
        if (err.name !== 'AbortError') setData(null);
      });
    
    fetchJson(`/api/dagonet/bets?${query}`, options)
      .then(setBettingData)
      .catch(err => {
        if (err.name !== 'AbortError') setBettingData(null);
      });

    fetchJson(`/api/dagonet/status?${query}`, options)
      .then(res => {
        if (typeof res.active === 'boolean') {
          setActive(res.active);
        } else {
          setActive(null);
        }
      })
      .catch(err => {
        if (err.name !== 'AbortError') setActive(null);
      });

    return () => controller.abort();
  }, [bot]);

  if (!data) {
    return (
      <div className="dagonet-container">
        <DagonetHeader bot={bot} active={active} onBotChange={selectBot} />
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="dagonet-container">
      <DagonetHeader bot={bot} active={active} onBotChange={selectBot} />
      <div className="dagonet-body">
        <div className="dagonet-sidebar">
          <BalanceInfo balance={data.balance} />
          <ProfitStats profits={data.profits} earnings={data.earnings} />
        </div>
        <div className="dagonet-main">
          <BettingChart bets={bettingData?.bets} />
          <BettingTable bets={bettingData?.bets} />
        </div>
      </div>
    </div>
  );
}
